// Intake `*Loading` flags that are NOT field saves, so `useIsIntakeSaving` can
// tell in-flight writes apart from everything else that also toggles a loader:
// the initial details fetch, the basic-info list fetch, sending the
// questionnaire to the guardian, and the conclude/submit request itself
// (tracked separately by `submitIntakeQuestionnaireLoading`).
export const INTAKE_NON_SAVE_LOADING_KEYS: readonly string[] = [
  'questionnaireDetailsLoading',
  'intakeQuestionnairesBasicInfoLoading',
  'sendIntakeQuestionnaireLoading',
  'submitIntakeQuestionnaireLoading',
];
